// @flow
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from './styles.css'
import { renderSelectField, renderTextAreaField, renderInputField } from 'components/FormFields'
import { STATUS_OPTIONS, INVESTMENT_TYPES } from 'lib/constants'
import { Button } from 'components/Button'
import { filterEmptyValues } from './subaccountUtils'

type Props = {
  handleSubmit: Function,
  submitting: boolean,
  pristine: boolean,
  reset: Function,
  dispatch: Function,
  onCancel: Function,
  initialValues: Object,
  subaccount: Object,
  accountNumber: string,
  subnumber: string,
  onSuccess: Function,
  onSubmit?: Function,
}

const IndividualInvestmentForm = (props: Props) => {
  const { handleSubmit, submitting, pristine, onCancel, onSuccess, initialValues } = props

  const isInvestmentTypePresent = initialValues && initialValues.investment_type

  const onSubmit = (values) => {
    const filteredValues = filterEmptyValues(values)

    return props.onSubmit ? props.onSubmit(filteredValues) : Promise.resolve()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.contentContainer}>
        <div className={styles.formRow}>
          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Investment Details</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field
                  name="investment_type"
                  component={renderSelectField}
                  label="Type of Individual Investment"
                  options={INVESTMENT_TYPES}
                  placeholder="Select Investment Type"
                  disabled={isInvestmentTypePresent}
                />
              </div>
              <div className={styles.docsWrapper}>
                <Field
                  name="contact_info"
                  component={renderTextAreaField}
                  label="Contact Information"
                  placeholder="Enter name, email, and phone"
                  cleaner={(val) => val && val.trim()}
                />
              </div>
              <div className={styles.docsWrapper}>
                <Field
                  name="statement_info"
                  type="text"
                  component={renderInputField}
                  label="Statement Delivery"
                  placeholder="ex: emailed, monthly"
                />
              </div>
            </section>
          </div>
          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Subaccount Status</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field name="status" component={renderSelectField} label="Current Status" options={STATUS_OPTIONS} placeholder="Select Status" />
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <Button size="default" color="red" label="Cancel" onClick={onCancel} type="button" disabled={submitting} />
        <Button size="default" color="blue" label="Save Changes" type="submit" disabled={pristine || submitting} />
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'individualInvestmentForm',
  enableReinitialize: true,
})(IndividualInvestmentForm)
